const projectQuickCreateOpen = ref(false)
const projectQuickCreateClientId = ref('')

export function useProjectQuickCreate() {
  function openProjectQuickCreate(clientId = '') {
    projectQuickCreateClientId.value = clientId
    projectQuickCreateOpen.value = true
  }

  function closeProjectQuickCreate() {
    projectQuickCreateOpen.value = false
  }

  return {
    isProjectQuickCreateOpen: projectQuickCreateOpen,
    projectQuickCreateClientId,
    openProjectQuickCreate,
    closeProjectQuickCreate,
  }
}
